import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { DependentHistoryContext } from "./DependentHistoryContext";

export const DependentHistoryInfo = () => {
    const avatar = process.env.PUBLIC_URL + "/assets/layout/images/avatar.png";
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["dependent-history", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const dependentHistoryContext = useContext(DependentHistoryContext);
    const { dependents, setDependents, dependent, setDependent, setDependentHistories, dependentHistoryDialog, setDependentHistoryDialog, dependentHistoryInfoDialog, setDependentHistoryInfoDialog } = dependentHistoryContext;

    const hideDialog = () => {
        setDependentHistoryInfoDialog(false);
    };
    return (
        <Dialog visible={dependentHistoryInfoDialog} style={{ width: "70%" }} header={t("dependent.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid mt-3 text-left">
                <BlockDetail title={t("dependent.list1")}>
                    <div className="grid ">
                        <div className="col-fixed" style={{ width: "250px" }}>
                            <img src={dependent?.avatar ? `data:image/jpeg;base64,${dependent?.avatar}` : avatar} width="100%" height={"300px"} alt=""></img>
                        </div>
                        <div className="col">
                            <div className="grid">
                                <div className="col-12">
                                    <div className="grid">
                                        {/* số cccd */}
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="idNumber" className="custom-form">
                                                {t("dependent.idNumber")}
                                            </label>
                                            <InputText id="idNumber" value={dependent?.idNumber} readOnly className="custom-form" />
                                        </div>

                                        {/* quê quán */}
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="permanentAddress2" className="custom-form">
                                                {t("dependent.permanentAddress2")}
                                            </label>
                                            <InputText id="permanentAddress2" value={dependent?.permanentAddress2} readOnly className="custom-form" tooltip={dependent?.permanentAddress2} tooltipOptions={{ position: "top" }} />
                                        </div>
                                    </div>

                                    <div className="grid">
                                        {/* họ và tên */}
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="fullName2" className="custom-form">
                                                {t("dependent.fullName2")}
                                            </label>
                                            <InputText id="fullName2" value={dependent?.fullName2} readOnly className="custom-form" tooltip={dependent?.fullName2} tooltipOptions={{ position: "top" }} />
                                        </div>

                                        {/* nơi thường trú */}
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="nativePlace2" className="custom-form">
                                                {t("dependent.nativePlace2")}
                                            </label>
                                            <InputText id="nativePlace2" value={dependent?.nativePlace2} readOnly className="custom-form" tooltip={dependent?.nativePlace2} tooltipOptions={{ position: "top" }} />
                                        </div>
                                    </div>

                                    <div className="grid">
                                        {/* ngày sinh */}
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="birthdate" className="custom-form">
                                                {t("dependent.birthdate")}
                                            </label>
                                            <InputText id="birthdate" value={dependent?.birthdate} readOnly className="custom-form" tooltip={dependent?.birthdate} tooltipOptions={{ position: "top" }} />
                                        </div>

                                        {/* đặc điểm dị hình */}
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="identification2" className="custom-form">
                                                {t("dependent.identification2")}
                                            </label>
                                            <InputText id="identification2" value={dependent?.identification2} readOnly className="custom-form" tooltip={dependent?.identification2} tooltipOptions={{ position: "top" }} />
                                        </div>
                                    </div>

                                    <div className="grid">
                                        {/* giới tính */}
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="gender" className="custom-form">
                                                {t("dependent.gender")}
                                            </label>
                                            <InputText id="gender" value={dependent?.gender} readOnly className="custom-form" />
                                        </div>

                                        {/* ngày cấp */}
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="issuedOn" className="custom-form">
                                                {t("dependent.issuedOn")}
                                            </label>
                                            <InputText id="issuedOn" value={dependent?.issuedOn} readOnly className="custom-form" />
                                        </div>

                                        {/* ngày hết hạn */}
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="expirationDate" className="custom-form">
                                                {t("dependent.expirationDate")}
                                            </label>
                                            <InputText id="expirationDate" value={dependent?.expirationDate} readOnly className="custom-form" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </BlockDetail>
            </div>
            <div className="grid">
                <div className="col-12">
                    <Button
                        style={{
                            width: "max-content",
                        }}
                        label={t("close", { ns: "common" })}
                        icon="pi pi-times"
                        onClick={hideDialog}
                    />
                </div>
            </div>
        </Dialog>
    );
};
